(() => {
  'use strict';
  if (window.EmeryWishlist) return;
  const configNode = document.getElementById('emery-wishlist-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.strings;
  const route = window.Shopify?.routes?.root || '/';
  const state = { view: 'bag', rows: [], loaded: false, loading: null, generation: 0, prompts: new Map(), candidates: new Map(), busy: new Set(), products: new Map(), cart: { items: [], item_count: 0 }, notice: '', loadError: '' };
  const drawer = () => document.getElementById('cart-drawer');
  const id = value => String(value || '').split('/').pop();
  const handle = row => row.productHandle || row.handle || '';
  const key = row => handle(row) + ':' + id(row.variantId);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const currency = () => window.Shopify?.currency?.active || config.currency;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency(), minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
  const productUrl = (slug, variant) => route + 'products/' + encodeURIComponent(slug) + (variant ? '?variant=' + encodeURIComponent(variant) : '');
  const imageUrl = raw => {
    if (!raw) return '';
    try { const url = new URL(typeof raw === 'object' ? raw.src || raw.url : raw, location.origin); if (url.protocol !== 'https:') return ''; url.searchParams.set('width', '220'); return url.href; } catch { return ''; }
  };
  const image = (src, title) => { const url = imageUrl(src); return url ? '<img src="' + escape(url) + '" alt="' + escape(title) + '" width="88" height="110" loading="lazy">' : '<span class="es-wishlist-image-placeholder" aria-hidden="true"></span>'; };
  const publicApi = { open: () => open('wishlist'), reconcileDrawer, get count() { return state.rows.length; }, get preserveRows() { return state.prompts.size > 0; } };
  window.EmeryWishlist = publicApi;

  const styledButtons = new WeakSet();
  const pendingProductRemovals = new Map();
  const compactHeader = window.matchMedia('(max-width: 999px)');
  function matchProductButton(button) {
    const primary = button.closest('buy-buttons')?.querySelector('button[type="submit"]') || button.parentElement?.querySelector('button[type="submit"]');
    if (primary) {
      const style = getComputedStyle(primary);
      for (const name of ['--button-background', '--button-text-color', '--button-outline-color']) {
        const value = style.getPropertyValue(name).trim();
        if (value && button.style.getPropertyValue(name) !== value) button.style.setProperty(name, value);
      }
    }
    for (const name of ['background', 'background-color', 'background-image', 'color', 'border', 'border-color', 'border-width', 'border-style', 'border-radius', 'transition']) if (button.style.getPropertyValue(name)) button.style.removeProperty(name);
    if (!styledButtons.has(button)) {
      styledButtons.add(button);
      new MutationObserver(records => {
        if (records.some(record => record.attributeName === 'style')) matchProductButton(button);
        if (records.some(record => record.attributeName === 'data-wishlist-pending')) reconcileProductRemoval(button);
      }).observe(button, { attributes: true, attributeFilter: ['style', 'data-wishlist-pending'] });
    }
  }
  function matchProductButtons(parent = document) {
    if (parent.matches?.('.wishlist-btn--icon-only') && !styledButtons.has(parent)) matchProductButton(parent);
    parent.querySelectorAll?.('.wishlist-btn--icon-only').forEach(button => { if (!styledButtons.has(button)) matchProductButton(button); });
  }
  function syncHeaderSearch(header) {
      const cart = header.querySelector('.header__cart-link');
      if (cart && !header.querySelector('#wishlist-header-btn')) {
        const item = document.createElement('li');
        item.className = 'relative mw-emery-wishlist';
        item.innerHTML = '<a href="/pages/wishlist" id="wishlist-header-btn" role="button" aria-haspopup="dialog" aria-label="' + escape(text.title) + '"><svg aria-hidden="true" focusable="false" width="27" height="27" class="header__nav-icon" viewBox="0 0 24 24" fill="none"><path d="M12 20.25c-.3 0-.6-.1-.8-.3C7.1 16.5 3 12.9 3 8.8 3 6.1 5.1 4 7.8 4c1.7 0 3.2.8 4.2 2.2C13 4.8 14.5 4 16.2 4 18.9 4 21 6.1 21 8.8c0 4.1-4.1 7.7-8.2 11.1-.2.2-.5.3-.8.3z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
        cart.before(item);
      }
      const heart = header.querySelector('#wishlist-header-btn');
      if (heart) heart.dataset.esHasSaved = String(state.rows.length > 0);
      const primary = header.querySelector('.header__primary-nav');
      const search = header.querySelector('.header__search-link');
      if (!primary || !search) return;
      if (compactHeader.matches) {
        let list = primary.querySelector('.es-mobile-search-list');
        if (!list) { list = document.createElement('ul'); list.className = 'contents unstyled-list es-mobile-search-list'; primary.appendChild(list); }
        if (search.parentElement !== list) list.appendChild(search);
      } else {
        const secondary = header.querySelector('.header__secondary-nav > ul');
        if (secondary && search.parentElement !== secondary) secondary.insertBefore(search, (heart?.closest('li')?.parentElement === secondary ? heart.closest('li') : heart?.parentElement === secondary ? heart : null) || cart);
        primary.querySelector('.es-mobile-search-list')?.remove();
      }
  }
  matchProductButtons();
  document.querySelectorAll('.header').forEach(syncHeaderSearch);
  compactHeader.addEventListener('change', () => document.querySelectorAll('.header').forEach(syncHeaderSearch));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      matchProductButtons(node);
      if (node.matches('.header')) syncHeaderSearch(node);
      else node.querySelectorAll('.header').forEach(syncHeaderSearch);
      const header = record.target.closest?.('.header');
      if (header) syncHeaderSearch(header);
    }
  }).observe(document.body, { childList: true, subtree: true });

  function identity() {
    const customer = config.customer ? { ...window.shopifyCustomer, ...config.customer } : (window.shopifyCustomer?.isLoggedIn ? window.shopifyCustomer : null);
    let token = null;
    if (!customer) {
      token = localStorage.getItem('wishlist_guest_token');
      if (!token) { token = crypto.randomUUID(); localStorage.setItem('wishlist_guest_token', token); }
    }
    return { customer, token };
  }

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 18000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok || data.success === false) throw new Error(typeof data.description === 'string' ? data.description : text.error);
      return data;
    } finally { clearTimeout(timeout); }
  }

  async function migrateGuestWishlist() {
    const { customer } = identity();
    if (!customer) return;
    const token = localStorage.getItem('wishlist_guest_token');
    if (!token) return;
    if (!window.__magicWishlistMigration) {
      const task = request('/a/magic-wishlist', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'migrate', shop: config.shop, guestToken: token })
      }).then(() => { localStorage.removeItem('wishlist_guest_token'); });
      window.__magicWishlistMigration = task;
      task.catch(() => { if (window.__magicWishlistMigration === task) window.__magicWishlistMigration = null; });
    }
    await window.__magicWishlistMigration;
    if (localStorage.getItem('wishlist_guest_token') === token) throw new Error(text.error);
  }

  async function magic(body) {
    await migrateGuestWishlist();
    const { customer, token } = identity();
    const params = new URLSearchParams({ shop: config.shop, _t: String(Date.now()) });
    if (token) params.set('guestToken', token);
    if (!body) return request('/a/magic-wishlist?' + params, { cache: 'no-store' });
    return request('/a/magic-wishlist', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: config.shop, type: 'WISHLIST', guestToken: token, customerId: customer?.id ? id(customer.id) : null, customerName: customer?.name || '', customerEmail: customer?.email || '', locale: document.documentElement.lang || 'en', ...body })
    });
  }

  async function getProduct(slug) {
    const cached = state.products.get(slug);
    if (cached && Date.now() - cached.time < 30000) return cached.value;
    const value = request(route + 'products/' + encodeURIComponent(slug) + '.js', { cache: 'no-store' });
    state.products.set(slug, { value, time: Date.now() });
    try { return await value; }
    catch (error) { if (state.products.get(slug)?.value === value) state.products.delete(slug); throw error; }
  }

  async function enrich(row) {
    const slug = handle(row);
    try {
      const product = await getProduct(slug);
      const variant = row.variantId ? product.variants.find(v => id(v.id) === id(row.variantId)) : product.variants.find(v => v.available) || product.variants[0];
      return { ...row, productHandle: slug, variantId: variant?.id || row.variantId, title: product.title, image: variant?.featured_image?.src || product.featured_image, variantTitle: variant?.title === 'Default Title' ? '' : variant?.title || '', livePrice: variant?.price, available: !!variant?.available, minimum: variant?.quantity_rule?.min || 1 };
    } catch { return { ...row, productHandle: slug, title: row.title || row.productTitle || slug.replace(/-/g, ' '), image: row.image || row.productImage, available: false, unavailable: true }; }
  }

  async function load(force = false, hydrate = state.view === 'wishlist') {
    if (state.loading && !force) return state.loading.then(() => hydrate && !state.hydrated ? load(false, true) : state.rows);
    const fresh = !force && state.loaded && Date.now() - state.lastLoaded < 15000;
    if (fresh && (!hydrate || state.hydrated)) return state.rows;
    const generation = ++state.generation;
    state.loadError = '';
    render();
    const task = (async () => {
      try {
        const result = fresh ? { success: true, wishlist: { items: state.rows } } : await magic();
        if (!result.success || !Array.isArray(result.wishlist?.items)) throw new Error(text.error);
        const raw = result.wishlist.items.filter(row => handle(row));
        const rows = hydrate ? [] : raw;
        if (hydrate) for (let start = 0; start < raw.length; start += 4) rows.push(...await Promise.all(raw.slice(start, start + 4).map(enrich)));
        if (generation !== state.generation) return;
        state.rows = rows;
        state.loaded = true;
        state.hydrated = hydrate;
        state.lastLoaded = Date.now();
        state.notice = '';
        render();
        return rows;
      } catch (error) {
        if (generation === state.generation) { state.loadError = text.error; render(); }
        throw error;
      } finally { if (generation === state.generation) state.loading = null; }
    })();
    state.loading = task;
    return task;
  }

  function updated(action, row) {
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { action, handle: handle(row), productHandle: handle(row), variantId: id(row.variantId), variantScoped: true, source: action === 'remove' ? 'heart' : 'emery', integration: 'emery', wishlist: state.rows.map(r => ({ handle: handle(r), variantId: id(r.variantId) })) } }));
  }

  async function saveItem(item) {
    const product = await getProduct(item.handle);
    const variant = product.variants.find(v => id(v.id) === id(item.variant_id || item.id));
    if (!variant) throw new Error(text.unavailable);
    const row = { productHandle: item.handle, variantId: id(variant.id) };
    await magic({ action: 'add', productId: item.handle, variantId: id(variant.id), variantTitle: variant.title, title: product.title, image: variant.featured_image?.src || product.featured_image, price: variant.price / 100, currencyCode: currency(), country: window.Shopify?.country || null, wasOOS: !variant.available });
    await load(true);
    if (!state.rows.some(r => key(r) === key(row))) throw new Error(text.error);
    updated('add', row);
  }

  async function removeSaved(row) {
    await magic({ action: 'remove', productId: handle(row), variantId: id(row.variantId) || null });
    await load(true);
    if (state.rows.some(r => key(r) === key(row))) throw new Error(text.error);
    updated('remove', row);
  }

  function reconcileProductRemoval(button) {
    const row = pendingProductRemovals.get(button);
    if (!row || button.dataset.wishlistPending === 'true') return;
    pendingProductRemovals.delete(button);
    load(true).then(rows => {
      if (rows && !rows.some(item => key(item) === key(row))) updated('remove', row);
    }).catch(() => {});
  }

  async function cartAdd(item, quantity = 1) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const line = { id: id(item.variantId || item.variant_id || item.id), quantity };
    const added = await request(route + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [line], sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }) });
    let cart;
    try { cart = await request(route + 'cart.js', { cache: 'no-store' }); }
    catch { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); return; }
    cart.sections = added.sections || {};
    if (!drawer()?.closest('.shopify-section') || !Object.values(cart.sections).some(Boolean)) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    else document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart, baseEvent: 'emery:add' } }));
  }

  function reconcileDrawer(next) {
    if (!state.inlineUpdate) return false;
    state.inlineUpdate = false;
    const element = drawer();
    const bag = element?.querySelector('[data-es-bag-panel]');
    const list = bag?.querySelector('.cart-drawer__items');
    if (!list) return false;
    const rowKey = row => row.querySelector('[data-line-key]')?.dataset.lineKey;
    const nextRows = [...next.querySelectorAll('.cart-drawer__items > line-item')];
    for (const row of [...list.querySelectorAll(':scope > line-item')]) {
      if ([...state.prompts.values()].some(record => record.node === row)) continue;
      const replacement = nextRows.find(candidate => rowKey(candidate) === rowKey(row));
      if (replacement && !row.hasAttribute('data-es-prompt')) {
        row.querySelector('price-list')?.replaceWith(replacement.querySelector('price-list') || row.querySelector('price-list'));
      } else row.remove();
    }
    nextRows.forEach((row, index) => {
      const active = [...list.querySelectorAll(':scope > line-item:not([data-es-prompt])')];
      if (!active.some(existing => rowKey(existing) === rowKey(row))) list.insertBefore(row, active[index] || null);
    });
    const cartJson = element.querySelector('[data-es-cart-json]');
    if (cartJson) cartJson.textContent = JSON.stringify(state.cart);
    const footer = element.querySelector('[data-es-bag-footer]');
    const nextFooter = next.querySelector('[data-es-bag-footer]');
    if (nextFooter && footer) footer.replaceChildren(...nextFooter.childNodes);
    else if (nextFooter) element.appendChild(nextFooter);
    const complementary = bag.querySelector('.cart-drawer__complementary-products');
    const nextComplementary = next.querySelector('[data-es-bag-panel] .cart-drawer__complementary-products');
    if (complementary && nextComplementary) complementary.replaceWith(nextComplementary);
    else if (nextComplementary) bag.appendChild(nextComplementary);
    else complementary?.remove();
    const shipping = bag.querySelector('.free-shipping-bar');
    const nextShipping = next.querySelector('.free-shipping-bar');
    if (shipping && nextShipping) { shipping.replaceChildren(...nextShipping.childNodes); shipping.style.visibility = ''; }
    else if (shipping) shipping.style.visibility = 'hidden';
    const empty = bag.querySelector('.empty-cart-drawer');
    const nextEmpty = next.querySelector('[data-es-bag-panel] .empty-cart-drawer');
    if (nextEmpty && !empty) list.after(nextEmpty);
    else if (!nextEmpty) empty?.remove();
    element.classList.remove('drawer--center-body');
    render();
    return true;
  }

  function rememberCart() {
    const node = drawer()?.querySelector('[data-es-cart-json]');
    if (!node) return;
    try { const cart = JSON.parse(node.textContent); state.cart = cart; } catch { }
  }

  function setView(view) {
    state.view = view;
    state.notice = '';
    render();
    if (view === 'wishlist') load().catch(() => {});
  }

  async function open(view) {
    const element = drawer();
    if (!element) return;
    setView(view);
    await customElements.whenDefined('cart-drawer');
    element.show();
  }

  function actionButton(action, label, itemKey, classes = 'es-text-action text-xs') {
    return '<button type="button" class="' + classes + '" data-es-action="' + action + '" data-es-key="' + escape(itemKey) + '"' + (state.busy.has(itemKey) ? ' disabled aria-busy="true"' : '') + '>' + escape(label) + '</button>';
  }

  function renderRows() {
    const element = drawer();
    const list = element?.querySelector('[data-es-wishlist-list]');
    if (!list) return;
    if (state.view !== 'wishlist') return;
    const signature = JSON.stringify([state.loaded, state.hydrated, state.loadError ? state.busy.has('retry') : false, state.rows, [...state.busy].filter(k => state.rows.some(r => key(r) === k)), state.loadError]);
    if (list.dataset.esSignature === signature) return;
    list.dataset.esSignature = signature;
    if (state.loadError || !state.loaded || !state.hydrated) {
      list.innerHTML = '<p class="es-wishlist-empty">' + escape(state.loadError || text.loading) + '</p>' + (state.loadError ? actionButton('retry', text.retry, 'retry') : '');
      return;
    }
    if (!state.rows.length) { list.innerHTML = '<div class="empty-cart-drawer es-wishlist-empty"><p class="empty-cart-drawer__title">' + escape(text.empty.replace(/\.$/, '')) + '</p><p class="empty-cart-drawer__text">' + escape(text.emptyHint) + '</p></div>'; return; }
    list.innerHTML = state.rows.map(row => {
      const itemKey = key(row);
      const url = productUrl(handle(row), row.variantId);
      const price = Number.isFinite(row.livePrice) ? money(row.livePrice) : text.unavailable;
      return '<article class="es-wishlist-item"><a class="es-wishlist-media" href="' + escape(url) + '">' + image(row.image, row.title) + '</a><div class="es-wishlist-info"><a href="' + escape(url) + '">' + escape(row.title) + '</a>' + (row.variantTitle ? '<p class="text-xs text-subdued">' + escape(row.variantTitle) + '</p>' : '') + '<p>' + escape(price) + '</p><div class="es-wishlist-actions">' + (row.available ? actionButton('add', text.add, itemKey, 'button button--outline es-wishlist-add') : '<span class="text-xs text-subdued">' + escape(row.unavailable ? text.unavailable : text.soldOut) + '</span>') + actionButton('remove', text.remove, itemKey) + '</div></div></article>';
    }).join('');
  }

  function renderPrompts() {
    const element = drawer();
    if (!element) return;
    element.querySelectorAll('[data-es-prompt]').forEach(node => { if (!state.prompts.has(node.dataset.esPrompt)) node.remove(); });
    const list = element.querySelector('.cart-drawer__items');
    const fallback = element.querySelector('[data-es-inline-prompts]');
    for (const [itemKey, record] of state.prompts) {
      const item = record.item;
      let prompt = record.node;
      if (!prompt) {
        prompt = document.createElement('div');
        prompt.className = 'line-item';
        prompt.innerHTML = image(item.image, item.product_title || item.title) + '<div class="line-item-info"><div class="v-stack justify-items-start gap-2"><p>' + escape(item.product_title || item.title) + '</p><p class="text-xs text-subdued">' + escape(item.variant_title || '') + '</p><div data-es-row-controls></div></div></div>';
        record.node = prompt;
      }
      prompt.classList.add('es-removed-line');
      prompt.dataset.esPrompt = itemKey;
      let controls = prompt.querySelector('[data-es-row-controls]');
      if (!controls) {
        controls = document.createElement('div');
        controls.dataset.esRowControls = '';
        prompt.querySelector('line-item-quantity')?.replaceWith(controls);
        if (!controls.parentNode) (prompt.querySelector('.line-item-info') || prompt).appendChild(controls);
      }
      const signature = record.error || 'ready';
      if (controls.dataset.esSignature !== signature) {
        controls.dataset.esSignature = signature;
        controls.innerHTML = '<p class="text-xs" role="status">' + escape(text.removed) + '</p><p class="text-xs text-subdued">' + escape(text.saveHint) + '</p><div class="es-save-prompt-actions">' + actionButton('save', text.save, itemKey) + actionButton('dismiss', text.dismiss, itemKey) + '</div>' + (record.error ? '<p class="text-xs es-wishlist-error" role="alert">' + escape(record.error) + '</p>' : '');
      }
      controls.querySelectorAll('button').forEach(button => { button.disabled = state.busy.has(itemKey); button.toggleAttribute('aria-busy', state.busy.has(itemKey)); });
      if (!element.contains(prompt)) {
        if (list) {
          const reference = [...list.children].filter(node => node.matches('line-item:not([data-es-prompt])'))[record.index];
          list.insertBefore(prompt, reference || null);
        } else fallback?.appendChild(prompt);
      }
    }
    element.querySelector('[data-es-bag-panel] .empty-cart-drawer')?.toggleAttribute('hidden', state.prompts.size > 0);
  }

  function render() {
    const element = drawer();
    if (!element) return;
    element.dataset.esView = state.view;
    const signIn = element.querySelector('.es-wishlist-sign-in a');
    if (signIn && config.loginUrl && signIn.getAttribute('href') !== config.loginUrl) signIn.setAttribute('href', config.loginUrl);
    const isWishlist = state.view === 'wishlist';
    element.dataset.esViewEmpty = String(isWishlist ? state.loaded && state.hydrated && !state.rows.length && !state.loadError : !state.cart.item_count && !state.prompts.size);
    element.setAttribute('aria-label', isWishlist ? text.title : text.bagTitle);
    const title = element.querySelector('[data-es-drawer-title]');
    if (title) title.textContent = isWishlist ? text.title : text.bagTitle;
    element.querySelector('[data-es-bag-panel]')?.toggleAttribute('hidden', isWishlist);
    element.querySelector('[data-es-wishlist-panel]')?.toggleAttribute('hidden', !isWishlist);
    element.dataset.esCartEmpty = String(!state.cart.item_count);
    element.querySelector('[data-es-bag-footer]')?.toggleAttribute('hidden', isWishlist || !state.cart.item_count);
    for (const tab of element.querySelectorAll('[data-es-tab]')) {
      const selected = tab.dataset.esTab === state.view;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    }
    const bagCount = element.querySelector('[data-es-bag-count]');
    const savedCount = element.querySelector('[data-es-wishlist-count]');
    if (bagCount) bagCount.textContent = '(' + (state.cart.item_count || 0) + ')';
    if (savedCount) savedCount.textContent = state.loaded ? '(' + state.rows.length + ')' : '';
    const notice = element.querySelector('[data-es-notice]');
    if (notice) { notice.textContent = state.notice; notice.hidden = !state.notice; }
    element.classList.toggle('es-drawer-top', isWishlist || state.prompts.size > 0);
    renderRows();
    renderPrompts();
    document.querySelectorAll('#wishlist-header-btn').forEach(heart => { heart.dataset.esHasSaved = String(state.rows.length > 0); });
  }

  async function act(button) {
    const action = button.dataset.esAction;
    const itemKey = button.dataset.esKey;
    const record = state.prompts.get(itemKey);
    const row = state.rows.find(r => key(r) === itemKey);
    if (state.busy.has(itemKey)) return;
    if (action === 'dismiss') { state.prompts.delete(itemKey); render(); return; }
    const oldFocus = { action, key: itemKey };
    state.busy.add(itemKey);
    if (record) record.error = '';
    render();
    try {
      switch (action) {
        case 'save': if (record) { await saveItem(record.item); state.prompts.delete(itemKey); } break;
        case 'remove': if (row) await removeSaved(row); break;
        case 'add': if (row) { await cartAdd(row, row.minimum || 1); state.notice = text.added; } break;
        case 'retry': await load(true); break;
      }
    } catch (error) {
      if (record) record.error = error.message === text.unavailable ? text.unavailable : text.error;
      else if (action !== 'retry' && !state.loadError) state.notice = error.message || text.error;
    } finally {
      state.busy.delete(itemKey);
      render();
      if (!document.activeElement || document.activeElement === document.body) {
        const target = [...(drawer()?.querySelectorAll('[data-es-action]') || [])].find(b => b.dataset.esKey === oldFocus.key && b.dataset.esAction === oldFocus.action) || drawer()?.querySelector('[data-es-tab][aria-selected="true"]');
        target?.focus({ preventScroll: true });
      }
    }
  }

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const heart = target.closest('#wishlist-header-btn,[data-wishlist-header]');
    if (heart && drawer()) { event.preventDefault(); event.stopImmediatePropagation(); open('wishlist'); return; }
    const toastView = target.closest('.mw-toast-view');
    if (toastView && drawer()) { event.preventDefault(); event.stopImmediatePropagation(); open('wishlist'); toastView.closest('.mw-toast')?.remove(); return; }
    const tab = target.closest('[data-es-tab]');
    if (tab) { event.preventDefault(); event.stopImmediatePropagation(); setView(tab.dataset.esTab); tab.focus(); return; }
    const action = target.closest('[data-es-action]');
    if (action) { event.preventDefault(); event.stopImmediatePropagation(); act(action); return; }
    if (target.closest('[aria-controls="cart-drawer"]')) setView('bag');
  }, true);

  document.addEventListener('keydown', event => {
    const tab = event.target.closest?.('[data-es-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 'bag' : event.key === 'End' ? 'wishlist' : state.view === 'bag' ? 'wishlist' : 'bag';
    setView(next);
    drawer()?.querySelector('[data-es-tab="' + next + '"]')?.focus();
  });

  document.addEventListener('line-item:will-change', event => {
    if (!event.target.closest?.('#cart-drawer') || event.detail?.targetQuantity !== 0) return;
    const lineKey = event.target.querySelector('[data-line-key]')?.dataset.lineKey;
    const index = state.cart.items.findIndex(item => item.key === lineKey);
    if (index >= 0) state.candidates.set(lineKey, { item: structuredClone(state.cart.items[index]), index, node: event.target.closest('line-item') });
  }, true);

  document.addEventListener('cart:change', event => {
    const cart = event.detail?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    state.inlineUpdate = [...state.candidates.keys()].some(lineKey => !cart.items.some(item => item.key === lineKey));
    for (const [lineKey, record] of state.prompts) if (cart.items.some(item => item.key === lineKey || (['emery:add', 'variant:add'].includes(event.detail.baseEvent) && id(item.variant_id || item.id) === id(record.item.variant_id || record.item.id)))) state.prompts.delete(lineKey);
    for (const [lineKey, record] of state.candidates) if (!cart.items.some(item => item.key === lineKey)) state.prompts.set(lineKey, record);
    state.candidates.clear();
    state.cart = cart;
    if (event.detail.baseEvent === 'variant:add') state.view = 'bag';
  }, true);

  document.addEventListener('cart-drawer:refreshed', () => { rememberCart(); render(); });
  window.addEventListener('wishlist:updated', event => {
    const detail = event.detail;
    if (detail?.integration === 'emery' || detail?.source === 'emery' || detail?.optimistic) return;
    if (detail?.source === 'btn' && detail.action === 'remove') {
      const slug = detail.handle || detail.productHandle;
      const button = [...document.querySelectorAll('.wishlist-btn--icon-only')].find(node => node.closest('[data-product-handle]')?.dataset.productHandle === slug);
      if (button && styledButtons.has(button)) {
        pendingProductRemovals.set(button, { productHandle: slug, variantId: detail.variantId });
        return;
      }
    }
    if (detail?.source === 'btn' && detail.action === 'revert' && pendingProductRemovals.size) return;
    load(true).catch(() => {});
  });
  window.addEventListener('pageshow', event => { if (event.persisted) load(true).catch(() => {}); });
  document.addEventListener('shopify:section:load', () => { rememberCart(); render(); });
  rememberCart();
  render();
  load().catch(() => {});
})();
